import { z } from 'zod';

export const discountCodeClaimSchema = z.object({
  discountCode: z.string(),
  restaurantId: z.string(),
  /** Phone number (consumer-web) or restaurantCustomerId (consumer-native). */
  customerIdentifier: z.string(),
  orderId: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type DiscountCodeClaim = z.output<typeof discountCodeClaimSchema>;

export const discountCodeClaimStrictSchema = discountCodeClaimSchema.safeExtend({});

export const discountCodeClaimCvxSchema = discountCodeClaimSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type DiscountCodeClaimCvx = z.output<typeof discountCodeClaimCvxSchema>;
